var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconeOtimizado(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.25755 0 0 .25755 -134.197 165.63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988.06-249.54h-437c-16.569 0-30-13.431-30-30v-254.63c0-16.569 13.431-30 30-30h437c16.569 0 30 13.431 30 30v254.63c0 16.569-13.431 30-30 30z",
    fill: "#655e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.06-564.17h-30c16.569 0 30 13.432 30 30v254.63c0 16.568-13.431 30-30 30h30c16.569 0 30-13.432 30-30v-254.63c0-16.569-13.431-30-30-30z",
    fill: "#544f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.06-282.54v-248.63a3 3 0 013-3h431a3 3 0 013 3v248.63a3 3 0 01-3 3h-431a3.001 3.001 0 01-3-3.001z",
    fill: "#9dc6fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.06-534.17h-30a3 3 0 013 3v248.63a3 3 0 01-3 3h30a3 3 0 003-3v-248.63a3 3 0 00-3-3z",
    fill: "#dceafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.425-612.044h-147.72c-7.76 0-14.052 6.29-14.052 14.052v320.885c0 7.761 6.291 14.052 14.052 14.052h225.962c7.76 0 14.052-6.29 14.052-14.052V-519.75c0-4.97-1.974-9.736-5.488-13.249l-73.56-73.56a18.733 18.733 0 00-13.248-5.488z",
    fill: "#f6f2f3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.71,
    y: -434.02,
    width: 145.47,
    height: 16.889,
    ry: 8.444,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.05,
    y: -436.83,
    width: 24.395,
    height: 22.518,
    ry: 11.259,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.71,
    y: -476.73,
    width: 145.47,
    height: 16.889,
    ry: 8.444,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.05,
    y: -479.54,
    width: 24.395,
    height: 22.518,
    ry: 11.259,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.71,
    y: -519.44,
    width: 145.47,
    height: 16.889,
    ry: 8.444,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.05,
    y: -522.25,
    width: 24.395,
    height: 22.518,
    ry: 11.259,
    fill: "#333c5d",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.33-248.309h58.456v46.184H740.33z",
    fill: "#c7c2c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.76-202.129h-92.405c-14.912 0-27 12.088-27 27a3 3 0 003 3h140.4a3 3 0 003-3c0-14.912-12.089-27-27-27z",
    fill: "#655e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.76-202.129h-30c14.912 0 27 12.088 27 27a3 3 0 01-3 3h30a3 3 0 003-3c0-14.912-12.089-27-27-27z",
    fill: "#544f56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.2-533.32l-25.229-25.229a18.739 18.739 0 015.487 13.248v242.64c0 7.761-6.291 14.052-14.052 14.052h-214.79v11.178c0 7.76 6.291 14.052 14.052 14.052h225.96c7.76 0 14.052-6.292 14.052-14.052v-242.64a18.74 18.74 0 00-5.487-13.249z",
    fill: "#fb9e93"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.17,
    y: -279.28,
    width: 340.88,
    height: 29.331,
    ry: 0,
    fill: "#655e67",
    paintOrder: "stroke fill markers"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeOtimizado);
export default __webpack_public_path__ + "static/media/icone-otimizado.f5a7fef8af45cb60056d226e48c773c3.svg";
export { ForwardRef as ReactComponent };